import * as angular from 'angular';
import {IController} from 'angular';
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {FulfillmentService} from "../../services/fulfillment-service.service";

export class AttemptInfoDialogViewComponent implements IController {

  fulfillmentId: string;
  step: any;
  subType : string;
  stepPriceInfo: any;
  attempt: any;
  attemptDetails: any;

  public timeline: any;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;

  constructor(private servicesService: ServicesService, private fulfillmentService: FulfillmentService) {
  }

  $onInit() {
    if (!this.attemptDetails) {
      this._getAttemptDetails();
    }
  }

  onTabSelect(tabIndex) {
    if (tabIndex === 4) {
      if (this.attempt.subType !== this.fulfillmentSubTypeType.ThirdParty) {
        this.servicesService.getLogsTimeline(this.attempt.id)
          .then((timeline) => {
            this.timeline = timeline;
          })
      }
    }
  }

  private _getAttemptDetails() {
    this.fulfillmentService.getStepAttemptInfo(this.fulfillmentId, this.step.id, this.attempt.id, this.attempt.subType)
      .then((attemptDetails) => {
        this.attemptDetails = attemptDetails;
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('attemptInfoDialogView', {
    bindings: {
      fulfillmentId: '<',
      step: '<',
      stepPriceInfo: '<?',
      attempt: '<',
      subType: '<?',
      attemptDetails: '<?'
    },
    template: require('./attempt-info-dialog-view.html').default,
    controller: AttemptInfoDialogViewComponent
  });
